import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography
} from '@mui/material'
import { SendInvitation } from '../../services/Types'
import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'
import { FC } from 'react'
import { flexItemCenter } from '../../global'

const useStyles = makeStyles({
  formLabel: {
    textAlign: 'left',
    width: 'full',
    gap: '12px'
    // margin: '0.25rem'
    // my: '14px'
  },

  errorBox: {
    height: '1.125rem'
  }
})

export interface RadioButton {
  name?: string
  selected: string
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  radioButtons: Array<{ value: string; label: string }>
}

export const RadioButton: FC<RadioButton> = ({
  name,
  selected,
  handleChange,
  radioButtons
}) => {
  const classes = useStyles()
  return (
    <Box sx={{ borderRadius: 0.25 }}>
      <RadioGroup
        name={name ? name : ''}
        value={selected}
        onChange={handleChange}
        sx={{ ml: { sm: 4, xs: 1.5 } }}
      >
        {radioButtons.map((radioButton, index) => (
          <FormControlLabel
            className={classes.formLabel}
            value={radioButton.value}
            sx={{ my: '6.5px' }}
            control={
              <Radio
                size='small'
                sx={{
                  width: '20px !important',
                  height: '20px !important',
                  m: '2px',
                  '&, &.Mui-checked': {
                    color: 'rgba(0, 0, 0, 0.6)'
                  }
                  // pt: '4px'
                }}
              />
            }
            label={<Typography>{radioButton.label}</Typography>}
          />
        ))}
      </RadioGroup>
    </Box>
  )
}
